import { Calendar as BigCalendar, momentLocalizer, Views } from "react-big-calendar";
import "./eventCalendar.css";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Calendar as PrimeCalendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import CustomModal from "../customModal/customModal";
import { useLocation, useNavigate } from "react-router-dom";

const localizer = momentLocalizer(moment);
const options = [
  { name: "Busy", val: 0 },
  { name: "Free", val: 1 },
];
const options1 = [
  { name: "Default visibility", val: 0 },
  { name: "Public", val: 1 },
  { name: "Private", val: 2 },
];
const options2 = [
  { name: "When event starts", val: 0 },
  { name: "15 minutes before", val: 1 },
  { name: "30 minutes before", val: 2 },
  { name: "1 hour before", val: 3 },
  { name: "2 hours before", val: 4 },
  { name: "1 day before", val: 5 },
];
const colorOptions = [
  { value: "#4285f4" }, // blue
  { value: "#34a853" }, // green
  { value: "#ea4335" }, // red
  { value: "#fbbc05" }, // yellow
  { value: "#a142f4" }, // purple
  { value: "#24c1e0" }, // cyan
];

const customModules = {
  toolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"]],
};

// 👇 Custom component for rendering events in month/week/day view
function CustomEvent({ event }) {
  return (
    <div className="calendar-content">
      <strong>{event.title}</strong>
      {event.message && <div style={{ fontSize: "0.75em", color: "#fff" }}>{event.message.length > 30 ? event.message.slice(0, 30) + "..." : event.message}</div>}
      {event.doctor && <div style={{ fontSize: "0.7em", color: "#fff" }}>Doctor: {event.doctor}</div>}
    </div>
  );
}

// 👇 Custom agenda event (for Agenda view)
function CustomAgendaEvent({ event }) {
  return (
    <span>
      <strong>{event.title}</strong>
      <br />
      {event.message && <em>{event.message}</em>}
      {event.doctor && <div>Doctor: {event.doctor}</div>}
      {event.location && <div>Location: {event.location}</div>}
    </span>
  );
}

function CustomToolbar({ label, onNavigate, onView, view, onCreateEvent }) {
  return (
    <div className="rbc-toolbar d-flex justify-content-between align-items-center">
      {/* Left Controls: Navigation */}
      <div className="rbc-btn-group rbc-btn-group-left">
        <button className="btn-today custom-today-button" onClick={() => onNavigate("TODAY")}>
          Today
        </button>
        <button className="btn-back custom-back-button" onClick={() => onNavigate("PREV")}>
          <i className="ri-arrow-left-s-line"></i>
        </button>

        <button className="btn-next custom-next-button" onClick={() => onNavigate("NEXT")}>
          <i className="ri-arrow-right-s-line"></i>
        </button>
        <span className="rbc-toolbar-label">{label}</span>
      </div>

      {/* Right Controls: View Switcher */}
      <div className="rbc-btn-group rbc-btn-group-right">
        <button type="button" className="create-event-btn" onClick={onCreateEvent}>
          <i className="ri-add-line"></i>&nbsp;Create event
        </button>
        {view === "agenda" ? (
          " "
        ) : (
          <select className="form-select custom-view-select" value={view} onChange={(e) => onView(e.target.value)}>
            <option value="month">Month</option>
            <option value="week">Week</option>
            <option value="day">Day</option>
          </select>
        )}

        <div className="grid-view">
          <button type="button" className={`${view === "agenda" ? "btn" : "btn btn-month-active"}`} onClick={() => onView("month")}>
            <i className="ri-calendar-event-line"></i>
          </button>
          <button type="button" className={`${view !== "agenda" ? "btn" : "btn btn-agenda-active"}`} onClick={() => onView("agenda")}>
            <i className="ri-list-check-3"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default function EventCalendar({ events = [] }) {
  const [date, setDate] = useState(new Date());
  const [entryType, setEntryType] = useState("event"); // "event" | "task"
  const [calendarView, setCalendarView] = useState(Views.MONTH);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const popupRef = useRef(null);
  const [myEvents, setMyEvents] = useState(events);
  const [popupVisible, setPopupVisible] = useState(false);
  const [readyToShow, setReadyToShow] = useState(false);
  const [popupStyle, setPopupStyle] = useState({ top: 0, left: 0 });
  const [editingField, setEditingField] = useState(null);
  const [showEventOptions, setShowEventOptions] = useState(false);
  const [selectedColor, setSelectedColor] = useState("#4285f4");
  const [showColors, setShowColors] = useState(false);
  // values: "title" | "message" | "date"

  const [showCreatePopup, setShowCreatePopup] = useState(false);
  const [newEventData, setNewEventData] = useState({
    id: Math.floor(Math.random() * 10000),
    title: "",
    message: "",
    doctor: "",
    location: "",
    start: new Date(),
    end: moment().add(1, "hour").toDate(), // default 1-hour event
  });

  const handleDayClick = useCallback((date) => {
    setNewEventData({
      id: Math.floor(Math.random() * 10000),
      title: "",
      message: "",
      doctor: "",
      location: "",
      start: date,
      end: moment(date).add(1, "hour").toDate(), // fixed 1-hour event
    });
    setShowCreatePopup(true);
  }, []);

  const saveInlineField = (field, value) => {
    const updatedEvent = {
      ...selectedEvent,
      [field]: value,
      ...(field === "start" ? { end: moment(value).add(30, "minutes").toDate() } : {}),
    };

    setMyEvents((prev) => prev.map((ev) => (ev.id === selectedEvent.id ? updatedEvent : ev)));

    setSelectedEvent(updatedEvent);
    setEditingField(null);
  };

  const ToggleField = ({ buttonText, children }) => {
    const [open, setOpen] = useState(false);

    return (
      <>
        {!open ? (
          <div className="event-text">
            <button type="button" className="btn" onClick={() => setOpen(true)}>
              {buttonText}
            </button>
          </div>
        ) : (
          React.cloneElement(children, {
            autoFocus: true,
            onBlur: () => setOpen(false),
          })
        )}
      </>
    );
  };

  const colorSquareTemplate = (option) => {
    if (!option) return null;

    return <div className="color-square" style={{ backgroundColor: option.value }} />;
  };

  // const handleSelectSlot = useCallback(({ start, end, action }) => {
  //   setNewEventData({ start, end });
  //   setShowCreatePopup(true);
  // }, []);

  // useEffect(() => {
  //   if (selectedEvent && modalRef.current) {
  //     const modal = new window.bootstrap.Modal(modalRef.current);
  //     modal.show();
  //   }
  // }, [selectedEvent]);

  useEffect(() => {
    if (popupVisible && readyToShow && popupRef.current) {
      setTimeout(() => {
        const popupRect = popupRef.current.getBoundingClientRect();
        const padding = 0;
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        // Use the last mouse click (or bounding box) position
        const anchorX = popupStyle.left === -9999 ? 0 : popupStyle.left;
        const anchorY = popupStyle.top === -9999 ? 0 : popupStyle.top;

        let top = anchorY + padding;
        let left = anchorX + padding;

        if (left + popupRect.width > screenWidth) {
          left = screenWidth - popupRect.width - padding;
        }

        if (top + popupRect.height > screenHeight) {
          top = screenHeight - popupRect.height - padding;
        }

        if (left < padding) {
          left = padding;
        }

        if (top < padding) {
          top = padding;
        }

        setPopupStyle({ top, left });
        setReadyToShow(false); // done measuring
      }, 200);
    }
  }, [popupVisible, readyToShow]);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const renderItem = () => {
    return (
      <form className="events-form">
        <div className="events-form-grid">
          <div className="form-group">
            <i className="ri-time-line"></i>
            <input className="form-control" type="text" placeholder="Event Title" value={newEventData.title} onChange={(e) => setNewEventData({ ...newEventData, title: e.target.value })} />
          </div>
          <div className="form-group">
            <i className="ri-time-line"></i>
            <PrimeCalendar
              id="newLeadCalendar"
              showTime
              hourFormat="12"
              value={newEventData.start}
              dateFormat="MM d, yy"
              onChange={(e) => {
                const startDate = e.target.value;
                const endDate = moment(startDate).add(1, "hour").toDate(); // auto 1 hour duration

                setNewEventData({
                  ...newEventData,
                  start: startDate,
                  end: endDate,
                });
              }}
            />
            <input className="form-control" type="text" placeholder="Time Zone" />
          </div>
          <div className="form-group">
            <i className="ri-time-line f-0"></i>
            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options1}
              optionLabel="name"
              optionValue="val"
              placeholder="Default visibility"
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <i className="ri-map-pin-line"></i>
            <input className="form-control" type="text" placeholder="Add location" />
          </div>
          <div className="form-group">
            <i className="ri-map-pin-line"></i>
            <button type="button" className="btn">
              Add Notification
            </button>
          </div>
          <div className="form-group">
            <i className="ri-calendar-event-line"></i>
            <button type="button" className="btn" onClick={() => setShowEventOptions((prev) => !prev)}>
              Ayatas admin
            </button>
            <Dropdown
              value={selectedColor}
              options={colorOptions}
              onChange={(e) => setSelectedColor(e.value)}
              optionValue="value"
              itemTemplate={colorSquareTemplate}
              valueTemplate={colorSquareTemplate}
              className="color-only-dropdown customised-dropdown"
              appendTo="self"
            />
          </div>
          <div className="form-group">
            <i className="ri-briefcase-line"></i>

            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options}
              optionLabel="name"
              optionValue="val"
              placeholder="Busy"
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <i class="ri-lock-line"></i>

            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options1}
              optionLabel="name"
              optionValue="val"
              placeholder="Default visibility"
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <i class="ri-notification-2-line"></i>

            <Dropdown
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.value)}
              options={options2}
              optionLabel="name"
              optionValue="val"
              placeholder="30 minutes before"
              appendTo="self"
              className="customised-dropdown"
            />
          </div>
          <div className="form-group">
            <i className="ri-bar-chart-horizontal-line"></i>
            <Editor className="texteditor editor-bottom-toolbar" placeholder="Click here to add text..." modules={customModules} />
          </div>
        </div>
        <div className="events-form-grid">
          <div className="form-group">
            <button type="submit" className="btn btn-primary event-btn">
              Save
            </button>
          </div>
          <div className="">
            <label>Guests</label>
            <input className="form-control" type="text" placeholder="Add location" />
          </div>
        </div>
      </form>
    );
  };

  return (
    <>
      <BigCalendar
        date={date}
        localizer={localizer}
        events={myEvents}
        startAccessor="start"
        endAccessor="end"
        view={calendarView}
        onNavigate={(newDate) => setDate(newDate)}
        onView={(view) => setCalendarView(view)}
        onSelectEvent={(event, e) => {
          setSelectedEvent(event);
          setPopupStyle({ top: e.clientY, left: e.clientX });
          setPopupVisible(true);
          setReadyToShow(true);
        }}
        popup
        // selectable
        // onSelectSlot={handleSelectSlot}
        onSelectSlot={({ start, action }) => {
          if (action === "click") {
            handleDayClick(start);
          }
        }}
        selectable="ignoreEvents"
        components={{
          event: CustomEvent,
          toolbar: (toolbarProps) => (
            <CustomToolbar
              {...toolbarProps}
              onCreateEvent={() => {
                setNewEventData({
                  title: "",
                  message: "",
                  doctor: "",
                  location: "",
                  start: new Date(),
                  end: moment().add(1, "hour").toDate(),
                });
                setShowCreatePopup(true);
                showEventOptions && setShowEventOptions(false);
              }}
            />
          ),
          agenda: {
            event: CustomAgendaEvent,
          },
        }}
      />
      <CustomModal renderItem={renderItem} title="Add New Event" visible={pathname.toLowerCase().includes("new-event")} />
      {showCreatePopup && (
        <div className="custom-event-popup custom-event-popup-new">
          <div className="popup-head">
            {/* <h5>Create New Event</h5> */}
            <button onClick={() => setShowCreatePopup(false)}>
              <i className="ri-close-line"></i>
            </button>
          </div>
          <div className="popup-body">
            <div className="rbc-event-text rbc-event-text-main">
              <input className="input-large" type="text" placeholder="Event Title" value={newEventData.title} onChange={(e) => setNewEventData({ ...newEventData, title: e.target.value })} />

              <div className="event-tab" id="nav-tab">
                <button
                  onClick={() => {
                    setEntryType("event");
                  }}
                  className={entryType === "event" ? "nav-link active" : "nav-link"}
                >
                  Event
                </button>
                <button
                  onClick={() => {
                    setEntryType("task");
                  }}
                  className={entryType === "task" ? "nav-link active" : "nav-link"}
                >
                  Task
                </button>
                <button
                  onClick={() => {
                    setEntryType("appointment");
                  }}
                  className={entryType === "appointment" ? "nav-link active" : "nav-link"}
                >
                  Appointment schedule
                </button>
              </div>
            </div>

            {entryType === "task" && (
              <>
                <div className="rcb-popup-content">
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-time-line"></i>
                    <div>
                      <PrimeCalendar
                        id="newLeadCalendar"
                        showTime
                        hourFormat="12"
                        value={newEventData.start}
                        dateFormat="MM d, yy"
                        onChange={(e) => {
                          const startDate = e.target.value;
                          const endDate = moment(startDate).add(1, "hour").toDate(); // auto 1 hour duration

                          setNewEventData({
                            ...newEventData,
                            start: startDate,
                            end: endDate,
                          });
                        }}
                      />
                      <input type="hidden" value={2} />
                    </div>
                  </div>
                  <div className="rbc-event-text rcb-event-control">
                    <i className="f-12">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 1.99999C12.5523 1.99999 13 2.4477 13 2.99999C12.9999 3.55224 12.5522 3.99999 12 3.99999C7.58172 3.99999 4 7.58171 4 12C4.00004 16.4182 7.58174 20 12 20C16.4182 20 19.9999 16.4182 20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12C21.9999 17.5228 17.5228 22 12 22C6.47717 22 2.00004 17.5228 2 12C2 6.47714 6.47715 1.99999 12 1.99999ZM12 5.99999C12.5523 5.99999 13 6.4477 13 6.99999C12.9999 7.55224 12.5522 7.99999 12 7.99999C9.79085 7.99999 7.99999 9.79085 7.99999 12C8.00004 14.2091 9.79088 16 12 16C14.2091 16 15.9999 14.2091 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C17.9999 15.3137 15.3137 18 12 18C8.68631 18 6.00004 15.3137 6 12C6 8.68628 8.68629 5.99999 12 5.99999ZM17.6562 2.10057C18.0468 1.71005 18.6807 1.71005 19.0713 2.10057C19.4614 2.49105 19.4615 3.12419 19.0713 3.51463L18.3633 4.22069L18.3642 4.22167C17.9737 4.61219 17.9737 5.2452 18.3642 5.63573C18.7548 6.02612 19.3878 6.02621 19.7783 5.63573L20.4853 4.9287C20.8759 4.53839 21.5089 4.53826 21.8994 4.9287C22.2899 5.31915 22.2897 5.95222 21.8994 6.34276L19.7783 8.46483C19.5909 8.65223 19.3363 8.75671 19.0713 8.75682H16.6572L12.707 12.707C12.3165 13.0974 11.6834 13.0974 11.293 12.707C10.9025 12.3165 10.9026 11.6835 11.293 11.293L15.2422 7.34374V4.9287C15.2422 4.66356 15.3477 4.40916 15.5351 4.22167L17.6562 2.10057Z"></path>
                      </svg>
                    </i>
                    <ToggleField buttonText="Add deadline">
                      <PrimeCalendar
                        id="newLeadCalendar"
                        showTime
                        hourFormat="12"
                        value={newEventData.start}
                        dateFormat="MM d, yy"
                        onChange={(e) => {
                          const startDate = e.target.value;
                          const endDate = moment(startDate).add(1, "hour").toDate(); // auto 1 hour duration

                          setNewEventData({
                            ...newEventData,
                            start: startDate,
                            end: endDate,
                          });
                        }}
                      />
                    </ToggleField>
                  </div>
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-bar-chart-horizontal-line"></i>
                    <textarea
                      placeholder="Description"
                      value={newEventData.message}
                      onChange={(e) =>
                        setNewEventData({
                          ...newEventData,
                          message: e.target.value,
                        })
                      }
                    />
                  </div>
                  {!showEventOptions && (
                    <div className="rbc-event-text rcb-event-control">
                      <i className="ri-calendar-event-line"></i>
                      <div className="event-text">
                        <button type="button" className="btn" onClick={() => setShowEventOptions((prev) => !prev)}>
                          Ayatas admin
                        </button>

                        <ul className="list-notification">
                          <li>Busy</li>
                          <li>Default visibility</li>
                        </ul>
                      </div>
                    </div>
                  )}
                  {showEventOptions && (
                    <>
                      <div className="rbc-event-text rcb-event-control">
                        <i className="ri-calendar-event-line"></i>
                        <button type="button" className="btn" onClick={() => setShowEventOptions((prev) => !prev)}>
                          Ayatas admin
                        </button>
                        <Dropdown
                          value={selectedColor}
                          options={colorOptions}
                          onChange={(e) => setSelectedColor(e.value)}
                          optionValue="value"
                          itemTemplate={colorSquareTemplate}
                          valueTemplate={colorSquareTemplate}
                          className="color-only-dropdown customised-dropdown"
                          appendTo="self"
                        />
                      </div>
                      <div className="rbc-event-text rcb-event-control">
                        <i className="ri-briefcase-line"></i>
                        <div>
                          <Dropdown
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.value)}
                            options={options}
                            optionLabel="name"
                            optionValue="val"
                            placeholder="Busy"
                            appendTo="self"
                            className="customised-dropdown"
                          />
                        </div>
                      </div>
                      <div className="rbc-event-text rcb-event-control">
                        <i class="ri-lock-line"></i>
                        <div>
                          <Dropdown
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.value)}
                            options={options1}
                            optionLabel="name"
                            optionValue="val"
                            placeholder="Default visibility"
                            appendTo="self"
                            className="customised-dropdown"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="tabpane-footer">
                  <button
                    className="event-btn"
                    onClick={() => {
                      if (newEventData.title) {
                        setMyEvents((prev) => [...prev, newEventData]);
                        setShowCreatePopup(false);
                      } else {
                        alert("Please enter a title.");
                      }
                    }}
                  >
                    Save
                  </button>
                </div>
              </>
            )}

            {entryType === "event" && (
              <>
                <div className="rcb-popup-content">
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-time-line"></i>
                    <div>
                      <PrimeCalendar
                        id="newLeadCalendar"
                        showTime
                        hourFormat="12"
                        value={newEventData.start}
                        dateFormat="MM d, yy"
                        onChange={(e) => {
                          const startDate = e.target.value;
                          const endDate = moment(startDate).add(1, "hour").toDate(); // auto 1 hour duration

                          setNewEventData({
                            ...newEventData,
                            start: startDate,
                            end: endDate,
                          });
                        }}
                      />
                      <input type="hidden" value={1} />
                    </div>
                  </div>
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-group-line"></i>
                    <ToggleField buttonText="Add guests">
                      <input type="text" className="form-control" />
                    </ToggleField>
                    {/* <span className="event-text">
                      <button type="button" className="btn">
                        Add guests
                      </button>
                      <input type="text" />
                    </span> */}
                  </div>
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-map-pin-line"></i>
                    <ToggleField buttonText="Add location">
                      <input type="text" className="form-control" />
                    </ToggleField>
                    {/* <span className="event-text">Add location</span> */}
                  </div>
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-bar-chart-horizontal-line"></i>
                    <ToggleField buttonText="Add description">
                      <Editor className="texteditor editor-bottom-toolbar" placeholder="Click here to add text..." modules={customModules} />
                    </ToggleField>
                  </div>
                  {!showEventOptions && (
                    <div className="rbc-event-text rcb-event-control">
                      <i className="ri-calendar-event-line"></i>
                      <div className="event-text">
                        <button type="button" className="btn" onClick={() => setShowEventOptions((prev) => !prev)}>
                          Ayatas admin
                        </button>

                        <ul className="list-notification">
                          <li>Busy</li>
                          <li>Default visibility</li>
                          <li>30 minutes before</li>
                        </ul>
                      </div>
                    </div>
                  )}
                  {showEventOptions && (
                    <>
                      <div className="rbc-event-text rcb-event-control">
                        <i className="ri-calendar-event-line"></i>
                        <button type="button" className="btn" onClick={() => setShowEventOptions((prev) => !prev)}>
                          Ayatas admin
                        </button>
                        <div>
                          <Dropdown
                            value={selectedColor}
                            options={colorOptions}
                            onChange={(e) => setSelectedColor(e.value)}
                            optionValue="value"
                            itemTemplate={colorSquareTemplate}
                            valueTemplate={colorSquareTemplate}
                            className="color-only-dropdown customised-dropdown"
                            appendTo="self"
                          />
                        </div>
                      </div>
                      <div className="rbc-event-text rcb-event-control">
                        <i className="ri-briefcase-line"></i>
                        <div>
                          <Dropdown
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.value)}
                            options={options}
                            optionLabel="name"
                            optionValue="val"
                            placeholder="Busy"
                            appendTo="self"
                            className="customised-dropdown"
                          />
                        </div>
                      </div>
                      <div className="rbc-event-text rcb-event-control">
                        <i class="ri-lock-line"></i>
                        <div>
                          <Dropdown
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.value)}
                            options={options1}
                            optionLabel="name"
                            optionValue="val"
                            placeholder="Default visibility"
                            appendTo="self"
                            className="customised-dropdown"
                          />
                        </div>
                      </div>
                      <div className="rbc-event-text rcb-event-control">
                        <i class="ri-notification-2-line"></i>
                        <div>
                          <Dropdown
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.value)}
                            options={options2}
                            optionLabel="name"
                            optionValue="val"
                            placeholder="30 minutes before"
                            appendTo="self"
                            className="customised-dropdown"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="tabpane-footer">
                  <button
                    type="button"
                    className="btn"
                    onClick={() => {
                      navigate("new-event");
                    }}
                  >
                    More options
                  </button>
                  <button
                    className="event-btn"
                    onClick={() => {
                      if (newEventData.title) {
                        setMyEvents((prev) => [...prev, newEventData]);
                        setShowCreatePopup(false);
                      } else {
                        alert("Please enter a title.");
                      }
                    }}
                  >
                    Save
                  </button>
                </div>
              </>
            )}

            {entryType === "appointment" && (
              <>
                <div className="rcb-popup-content">
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-time-line"></i>
                    <div>
                      <PrimeCalendar
                        id="newLeadCalendar"
                        showTime
                        hourFormat="12"
                        value={newEventData.start}
                        dateFormat="MM d, yy"
                        onChange={(e) => {
                          const startDate = e.target.value;
                          const endDate = moment(startDate).add(1, "hour").toDate(); // auto 1 hour duration

                          setNewEventData({
                            ...newEventData,
                            start: startDate,
                            end: endDate,
                          });
                        }}
                      />
                      <input type="hidden" value={2} />
                    </div>
                  </div>
                  <div className="rbc-event-text rcb-event-control">
                    <i className="ri-calendar-event-line"></i>
                    <div className="event-text">
                      <button type="button" className="btn">
                        Ayatas admin
                      </button>
                    </div>
                  </div>
                </div>
                <div className="tabpane-footer">
                  <button
                    className="event-btn"
                    onClick={() => {
                      if (newEventData.title) {
                        setMyEvents((prev) => [...prev, newEventData]);
                        setShowCreatePopup(false);
                      } else {
                        alert("Please enter a title.");
                      }
                    }}
                  >
                    Save
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {selectedEvent && popupVisible && (
        <div
          ref={popupRef}
          className="custom-event-popup"
          style={{
            top: popupStyle.top,
            left: popupStyle.left,
            visibility: popupVisible ? "visible" : "hidden",
          }}
        >
          <div className="popup-head">
            <button>
              <i className="ri-delete-bin-line"></i>
            </button>

            <button>
              <i className="ri-more-2-fill"></i>
            </button>
            <button
              onClick={() => {
                setSelectedEvent(null);
                setPopupVisible(false);
              }}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
          <div className="popup-body">
            <div className="rbc-event-title">
              <i className="ri-square-fill"></i>
              {editingField === "title" ? (
                <input
                  autoFocus
                  className="inline-input"
                  defaultValue={selectedEvent.title}
                  onBlur={(e) => saveInlineField("title", e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.target.blur();
                  }}
                />
              ) : (
                <h4 onClick={() => setEditingField("title")}>{selectedEvent.title}</h4>
              )}
            </div>
            <div className="rbc-event-date">
              {/* <span>
                {moment(selectedEvent.start).format("dddd, MMMM DD")} &nbsp;- &nbsp;
                {moment(selectedEvent.start).format("hh:mm A")}
              </span> */}
              {editingField === "start" ? (
                <PrimeCalendar
                  autoFocus
                  showTime
                  hourFormat="12"
                  value={selectedEvent.start}
                  onChange={(e) => {
                    saveInlineField("start", e.target.value);
                  }}
                  onHide={() => {
                    setEditingField(null); // close ONLY after calendar closes
                  }}
                />
              ) : (
                <p onClick={() => setEditingField("start")}>{moment(selectedEvent.start).format("MMM DD, YYYY hh:mm A")}</p>
              )}
            </div>
            {selectedEvent.doctor && (
              <p className="rbc-event-text">
                <i className="ri-group-fill"></i>2 guests
              </p>
            )}

            <p className="rbc-event-text">
              <i className="ri-bar-chart-horizontal-line"></i>
              {editingField === "message" ? (
                <textarea autoFocus className="inline-textarea" defaultValue={selectedEvent.message || ""} onBlur={(e) => saveInlineField("message", e.target.value)} />
              ) : (
                <p onClick={() => setEditingField("message")}>{selectedEvent.message || "Add description"}</p>
              )}
            </p>

            {selectedEvent.location && (
              <p className="rbc-event-text">
                <i className="ri-map-pin-5-line"></i>
                {selectedEvent.location}
              </p>
            )}
            <p className="rbc-event-text">
              <i className="ri-notification-3-line"></i> notifications
            </p>
            <p className="rbc-event-text">
              <i className="ri-shield-user-line"></i> Ramesh Kuppili
            </p>
          </div>
          <div className="popup-foot">
            <h6>Going?</h6>
            <div>
              <button type="button">Yes</button>
              <button type="button">No</button>
              <button type="button">Maybe</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
